/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateAreaManagerStoreAssignmentRequest } from '../models/CreateAreaManagerStoreAssignmentRequest';
import type { CreateEmployeeRequest } from '../models/CreateEmployeeRequest';
import type { CreateManagementAccountRequest } from '../models/CreateManagementAccountRequest';
import type { DeleteBindingRequest } from '../models/DeleteBindingRequest';
import type { OffboardRequest } from '../models/OffboardRequest';
import type { RevokeEmployeeTokensRequest } from '../models/RevokeEmployeeTokensRequest';
import type { SuccessResponse_CreateAreaManagerStoreAssignmentResponse_ } from '../models/SuccessResponse_CreateAreaManagerStoreAssignmentResponse_';
import type { SuccessResponse_CreateEmployeeResponse_ } from '../models/SuccessResponse_CreateEmployeeResponse_';
import type { SuccessResponse_CreateManagementAccountResponse_ } from '../models/SuccessResponse_CreateManagementAccountResponse_';
import type { SuccessResponse_DeleteBindingResponse_ } from '../models/SuccessResponse_DeleteBindingResponse_';
import type { SuccessResponse_EmployeeDetailResponse_ } from '../models/SuccessResponse_EmployeeDetailResponse_';
import type { SuccessResponse_EmployeeDirectoryResponse_ } from '../models/SuccessResponse_EmployeeDirectoryResponse_';
import type { SuccessResponse_EmployeeListResponse_ } from '../models/SuccessResponse_EmployeeListResponse_';
import type { SuccessResponse_EmployeeMeResponse_ } from '../models/SuccessResponse_EmployeeMeResponse_';
import type { SuccessResponse_EmployeeSearchResponse_ } from '../models/SuccessResponse_EmployeeSearchResponse_';
import type { SuccessResponse_list_PositionOption__ } from '../models/SuccessResponse_list_PositionOption__';
import type { SuccessResponse_ListAreaManagerStoreAssignmentsResponse_ } from '../models/SuccessResponse_ListAreaManagerStoreAssignmentsResponse_';
import type { SuccessResponse_OffboardResponse_ } from '../models/SuccessResponse_OffboardResponse_';
import type { SuccessResponse_RevokeEmployeeTokensResponse_ } from '../models/SuccessResponse_RevokeEmployeeTokensResponse_';
import type { SuccessResponse_StoreStaffOverviewResponse_ } from '../models/SuccessResponse_StoreStaffOverviewResponse_';
import type { SuccessResponse_TransferEmployeeResponse_ } from '../models/SuccessResponse_TransferEmployeeResponse_';
import type { SuccessResponse_UnbindAreaManagerStoreResponse_ } from '../models/SuccessResponse_UnbindAreaManagerStoreResponse_';
import type { SuccessResponse_UpdateEmployeeResponse_ } from '../models/SuccessResponse_UpdateEmployeeResponse_';
import type { TransferEmployeeRequest } from '../models/TransferEmployeeRequest';
import type { UnbindAreaManagerStoreRequest } from '../models/UnbindAreaManagerStoreRequest';
import type { UpdateEmployeeRequest } from '../models/UpdateEmployeeRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EmployeesService {
    /**
     * List Positions Endpoint
     * 所有已登录员工可读的岗位 code/中文名清单。
     * @returns SuccessResponse_list_PositionOption__ Successful Response
     * @throws ApiError
     */
    public static listPositionsEndpointApiV1EmployeesPositionsGet(): CancelablePromise<SuccessResponse_list_PositionOption__> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employees/positions',
        });
    }
    /**
     * Create Management Account Endpoint
     * Create a management profile without reopening legacy employee backfill.
     * @returns SuccessResponse_CreateManagementAccountResponse_ Successful Response
     * @throws ApiError
     */
    public static createManagementAccountEndpointApiV1ManagementAccountsPost({
        requestBody,
    }: {
        requestBody: CreateManagementAccountRequest,
    }): CancelablePromise<SuccessResponse_CreateManagementAccountResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/management-accounts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Employee Directory Endpoint
     * GET /api/v1/employees/directory — 财务直营员工只读目录.
     * @returns SuccessResponse_EmployeeDirectoryResponse_ Successful Response
     * @throws ApiError
     */
    public static listEmployeeDirectoryEndpointApiV1EmployeesDirectoryGet({
        brand = 'all',
        storeId,
        position,
        status = 'active',
        recordStatus = 'all',
        organizationStatus = 'all',
        keyword,
        limit = 500,
    }: {
        brand?: string,
        storeId?: (number | null),
        position?: (string | null),
        status?: string,
        recordStatus?: string,
        organizationStatus?: string,
        keyword?: (string | null),
        limit?: number,
    }): CancelablePromise<SuccessResponse_EmployeeDirectoryResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employees/directory',
            query: {
                'brand': brand,
                'store_id': storeId,
                'position': position,
                'status': status,
                'record_status': recordStatus,
                'organization_status': organizationStatus,
                'keyword': keyword,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Me Endpoint
     * GET /api/v1/employees/me — 自己的档案.
     * @returns SuccessResponse_EmployeeMeResponse_ Successful Response
     * @throws ApiError
     */
    public static getMeEndpointApiV1EmployeesMeGet(): CancelablePromise<SuccessResponse_EmployeeMeResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employees/me',
        });
    }
    /**
     * List Employees Endpoint
     * GET /api/v1/stores/{store_id}/employees — 查看门店花名册.
     * @returns SuccessResponse_EmployeeListResponse_ Successful Response
     * @throws ApiError
     */
    public static listEmployeesEndpointApiV1StoresStoreIdEmployeesGet({
        storeId,
        boundStatus,
        recordStatus = 'all',
        organizationStatus = 'all',
        limit = 50,
    }: {
        storeId: number,
        boundStatus?: (string | null),
        recordStatus?: string,
        organizationStatus?: string,
        limit?: number,
    }): CancelablePromise<SuccessResponse_EmployeeListResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/stores/{store_id}/employees',
            path: {
                'store_id': storeId,
            },
            query: {
                'bound_status': boundStatus,
                'record_status': recordStatus,
                'organization_status': organizationStatus,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Employee Endpoint
     * POST /api/v1/stores/{store_id}/employees — 店长录入员工 (D6 yes §0.5 #5).
     * @returns SuccessResponse_CreateEmployeeResponse_ Successful Response
     * @throws ApiError
     */
    public static createEmployeeEndpointApiV1StoresStoreIdEmployeesPost({
        storeId,
        requestBody,
    }: {
        storeId: number,
        requestBody: CreateEmployeeRequest,
    }): CancelablePromise<SuccessResponse_CreateEmployeeResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/stores/{store_id}/employees',
            path: {
                'store_id': storeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Search Employees Endpoint
     * GET /api/v1/employees/search — 总览态全局搜员工 (DISC-325 方案B第一步).
     *
     * owner/super_admin 全公司, area_manager 名下门店; 店长走本店花名册不开此口。
     * @returns SuccessResponse_EmployeeSearchResponse_ Successful Response
     * @throws ApiError
     */
    public static searchEmployeesEndpointApiV1EmployeesSearchGet({
        query,
        limit = 20,
    }: {
        query: string,
        limit?: number,
    }): CancelablePromise<SuccessResponse_EmployeeSearchResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employees/search',
            query: {
                'query': query,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Store Staff Overview Endpoint
     * GET /api/v1/staff/store-overview — 老板/区经员工管理第一屏门店汇总 (只读).
     *
     * spec: docs/prd/employee-mgmt-owner/spec.md §3.1 方案 A.
     *
     * 每店一行: {store_id, short_name, store_name, brand_name, active_count(在册),
     * bound_count(已绑定), on_duty_today(今日打上班卡 distinct), attendance_anomaly_count}.
     *
     * 鉴权 (spec §6, 与 owner-home summary 同源):
     * - super_admin god-mode 由 require_role 自动放行 (auth.py:285).
     * - owner / finance / area_manager 白名单放行; store_manager / staff / hq_ops → 403.
     * - scoping: service 层 visible_store_ids (owner/finance→全直营, area→名下店)
     * + enter_system_read + 显式 ANY(:ids) 双层 (DISC-058), area 绝不见全公司.
     * @returns SuccessResponse_StoreStaffOverviewResponse_ Successful Response
     * @throws ApiError
     */
    public static getStoreStaffOverviewEndpointApiV1StaffStoreOverviewGet(): CancelablePromise<SuccessResponse_StoreStaffOverviewResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/staff/store-overview',
        });
    }
    /**
     * Get Employee Detail Endpoint
     * GET /api/v1/employees/{employee_id}/detail — 查看员工详情 (only-read, D6 exempt).
     * @returns SuccessResponse_EmployeeDetailResponse_ Successful Response
     * @throws ApiError
     */
    public static getEmployeeDetailEndpointApiV1EmployeesEmployeeIdDetailGet({
        employeeId,
    }: {
        employeeId: number,
    }): CancelablePromise<SuccessResponse_EmployeeDetailResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employees/{employee_id}/detail',
            path: {
                'employee_id': employeeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Employee Endpoint
     * PATCH /api/v1/employees/{employee_id} — 店长编辑员工基础档案.
     * @returns SuccessResponse_UpdateEmployeeResponse_ Successful Response
     * @throws ApiError
     */
    public static updateEmployeeEndpointApiV1EmployeesEmployeeIdPatch({
        employeeId,
        requestBody,
    }: {
        employeeId: number,
        requestBody: UpdateEmployeeRequest,
    }): CancelablePromise<SuccessResponse_UpdateEmployeeResponse_> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/employees/{employee_id}',
            path: {
                'employee_id': employeeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Transfer Employee Endpoint
     * POST /api/v1/employees/{employee_id}/transfer — 原子调整岗位与直属上级.
     * @returns SuccessResponse_TransferEmployeeResponse_ Successful Response
     * @throws ApiError
     */
    public static transferEmployeeEndpointApiV1EmployeesEmployeeIdTransferPost({
        employeeId,
        requestBody,
    }: {
        employeeId: number,
        requestBody: TransferEmployeeRequest,
    }): CancelablePromise<SuccessResponse_TransferEmployeeResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/employees/{employee_id}/transfer',
            path: {
                'employee_id': employeeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Offboard Employee Endpoint
     * POST /api/v1/employees/{employee_id}/offboard — 店长归档员工 (D6 yes §0.5 #6).
     * @returns SuccessResponse_OffboardResponse_ Successful Response
     * @throws ApiError
     */
    public static offboardEmployeeEndpointApiV1EmployeesEmployeeIdOffboardPost({
        employeeId,
        requestBody,
    }: {
        employeeId: number,
        requestBody: OffboardRequest,
    }): CancelablePromise<SuccessResponse_OffboardResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/employees/{employee_id}/offboard',
            path: {
                'employee_id': employeeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Employee Binding Endpoint
     * DELETE /api/v1/employees/{employee_id}/binding — 店长解绑员工 (D6 yes §0.5 #7).
     * @returns SuccessResponse_DeleteBindingResponse_ Successful Response
     * @throws ApiError
     */
    public static deleteEmployeeBindingEndpointApiV1EmployeesEmployeeIdBindingDelete({
        employeeId,
        requestBody,
    }: {
        employeeId: number,
        requestBody: DeleteBindingRequest,
    }): CancelablePromise<SuccessResponse_DeleteBindingResponse_> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/employees/{employee_id}/binding',
            path: {
                'employee_id': employeeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Revoke Employee Tokens Endpoint
     * POST /api/v1/employees/{id}/revoke-tokens — 管理员强制员工重新登录.
     * @returns SuccessResponse_RevokeEmployeeTokensResponse_ Successful Response
     * @throws ApiError
     */
    public static revokeEmployeeTokensEndpointApiV1EmployeesEmployeeIdRevokeTokensPost({
        employeeId,
        requestBody,
    }: {
        employeeId: number,
        requestBody: RevokeEmployeeTokensRequest,
    }): CancelablePromise<SuccessResponse_RevokeEmployeeTokensResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/employees/{employee_id}/revoke-tokens',
            path: {
                'employee_id': employeeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Unbind Area Manager Store Endpoint
     * POST /api/v1/area-managers/{employee_id}/unbind-store — 解绑 area_manager 与某门店.
     *
     * v0.10.0 OQ-6 D 方案 (Ricky 拍板, oq-resolutions.md):
     * 解绑时该店"待审批 work_request" cascading 转交:
     * - 显式 successor → 转给接班人 (校验是 active area_manager + 持有该 store assignment)
     * - 无 successor → fallback 上级 (owner → super_admin)
     * 历史 inspection / 已完成 work_request 不动 (保留 audit trail).
     *
     * 鉴权: require_role('owner') (老板才能解绑 am); super_admin god-mode 由 auth 自动放行.
     * 限流: 同 actor 1 分钟 30 次 (低频管理操作).
     *
     * Response:
     * - affected_pending_work_requests: 转交了多少待审批
     * - transferred_to_employee_id / transferred_to_role: 实际转给谁 / 什么角色
     * - assignment_effective_to: 旧 assignment 的 effective_to (审计回执)
     * @returns SuccessResponse_UnbindAreaManagerStoreResponse_ Successful Response
     * @throws ApiError
     */
    public static unbindAreaManagerStoreEndpointApiV1AreaManagersEmployeeIdUnbindStorePost({
        employeeId,
        requestBody,
    }: {
        employeeId: number,
        requestBody: UnbindAreaManagerStoreRequest,
    }): CancelablePromise<SuccessResponse_UnbindAreaManagerStoreResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/area-managers/{employee_id}/unbind-store',
            path: {
                'employee_id': employeeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Area Manager Store Assignments Endpoint
     * GET /api/v1/area-managers/{employee_id}/store-assignments — area_manager 名下门店列表.
     *
     * v0.10.0 DISC-127 闭合 PR3 frontend AreaManagerStoresSection 占位 → 真数据二轮.
     *
     * Query:
     * - ``include_history``: false (默认) 仅返当前有效; true 返全部 (含历史).
     *
     * Response:
     * - ``items``: 单条含 assignment_id / area_manager_id / store_id / store_name_cn /
     * effective_from / effective_to (NULL=当前有效) / created_by / created_at / version.
     *
     * 鉴权: require_role('owner') + super_admin god-mode (auth 自动放行).
     * 限流: 同 actor 1 分钟 60 次 (高频 UI 读路径, 与列表 endpoint 同).
     * @returns SuccessResponse_ListAreaManagerStoreAssignmentsResponse_ Successful Response
     * @throws ApiError
     */
    public static listAreaManagerStoreAssignmentsEndpointApiV1AreaManagersEmployeeIdStoreAssignmentsGet({
        employeeId,
        includeHistory = false,
    }: {
        employeeId: number,
        /**
         * false=仅当前有效, true=含历史 (按 effective_from DESC)
         */
        includeHistory?: boolean,
    }): CancelablePromise<SuccessResponse_ListAreaManagerStoreAssignmentsResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/area-managers/{employee_id}/store-assignments',
            path: {
                'employee_id': employeeId,
            },
            query: {
                'include_history': includeHistory,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Area Manager Store Assignment Endpoint
     * POST /api/v1/area-managers/{employee_id}/store-assignments — 自助挂载单店.
     *
     * v0.10.0 DISC-127 Admin AreaManagerStoresSection "[+ 新增门店]" 按钮真接口.
     *
     * Body:
     * - ``store_id`` (必填 ge=1): 要挂载到的门店.
     * - ``effective_from`` (可选, 默认今天 / Asia/Shanghai): 生效日期.
     *
     * Response (201):
     * - 新建 assignment 完整快照 + store_name_cn.
     *
     * 业务规则:
     * - target 必须 active area_manager (非则 400 TARGET_ROLE_MISMATCH 或 404 EMPLOYEE_NOT_FOUND).
     * - store_id 必须 active 门店 (非则 422 STORE_NOT_FOUND).
     * - 该 store 当前未被另一 active area_manager 持有 (409 STORE_ALREADY_ASSIGNED).
     * - 同事务原子写 area_store_assignment + event_log 'area_manager.store_assigned'.
     *
     * 鉴权: require_role('owner') + super_admin god-mode + require_binding_active (D6).
     * 限流: 同 actor 1 分钟 30 次 (低频管理操作, 与 unbind 同).
     * @returns SuccessResponse_CreateAreaManagerStoreAssignmentResponse_ Successful Response
     * @throws ApiError
     */
    public static createAreaManagerStoreAssignmentEndpointApiV1AreaManagersEmployeeIdStoreAssignmentsPost({
        employeeId,
        requestBody,
    }: {
        employeeId: number,
        requestBody: CreateAreaManagerStoreAssignmentRequest,
    }): CancelablePromise<SuccessResponse_CreateAreaManagerStoreAssignmentResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/area-managers/{employee_id}/store-assignments',
            path: {
                'employee_id': employeeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
